import { saveAs } from 'file-saver';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useEffect, useState } from "react";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import Modal from 'react-modal';
import Select from 'react-select';
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import { getApi, postApi } from "../Admin Master/Area Control/Zonemaster/ServicesApi";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";


function Purchase() {
    const [openRow, setOpenRow] = useState(null);
    const [state, setState] = useState([]);                    // to get state data
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [purchaseList, setPurchaseList] = useState([]);
    const [getVendor, setGetVendor] = useState([])
    const [purchaseData, setPurchaseData] = useState({
        PurchaseId: "",
        PurchaseDate: new Date(),
        VendorCode: "",
        LocationCode: JSON.parse(localStorage.getItem("Login"))?.Branch_Code || "",
        VendorInvoiceNo: "",
        VendorInvoiceDate: new Date(),
        GstNo: "",
        StateCode: "",
        PaymentTerms: "",
        ItemName: "",
        Qty: 0,
        Rate: 0,
        Remark: ""
    });                                                       // to add vendor data



    const filteredPurchase = purchaseList.filter((item) =>
        item.Vendor_Name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.ItemName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.VendorInvoiceNo?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = filteredPurchase.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(filteredPurchase.length / rowsPerPage);

    const handleSearchChange = (e) => { setSearchQuery(e.target.value); setCurrentPage(1); };



    const fetchPurchase = async () => {
        try {
            const response = await getApi('/GetPurchaseVoucher');
            setPurchaseList(response.data);
        } catch (err) {
            console.error('Fetch Error:', err);
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchPurchase();
    }, []);



    useEffect(() => {
        const fetchData = async (link, setData) => {
            try {
                const response = await getApi(link);
                setData(Array.isArray(response.Data) ? response.Data : []);
            } catch (err) {
                console.error('Fetch Error:', err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData('/Master/getVendor', setGetVendor);
        fetchData('/Master/GetState', setState);
    }, []);


    
    const convertDate = (dateStr) => {
        if (!dateStr) return new Date();

        const [day, month, year] = dateStr.split("/");

        return new Date(year, month - 1, day);
    };

    const handleSave = async (e) => {
        e.preventDefault();

        const errors = [];

        if (!purchaseData.PurchaseDate) errors.push("Purchase Date is required");
        if (!purchaseData.VendorCode) errors.push("Vendor is required");
        if (!purchaseData.ItemName) errors.push("Item Name is required");
        if (!purchaseData.Qty) errors.push("Quantity is required");
        if (!purchaseData.Rate) errors.push("Rate is required");

        if (errors.length > 0) {
            Swal.fire({
                icon: "error",
                title: "Validation Error",
                html: errors.map(err => `<div>${err}</div>`).join("")
            });
            return;
        }

        const requestBody = {
            PurchaseDate: purchaseData.PurchaseDate?.toISOString().split("T")[0],
            VendorCode: purchaseData.VendorCode,
            LocationCode: purchaseData.LocationCode,
            VendorInvoiceNo: purchaseData.VendorInvoiceNo,
            VendorInvoiceDate: purchaseData.VendorInvoiceDate?.toISOString().split("T")[0],
            GstNo: purchaseData.GstNo,
            StateCode: purchaseData.StateCode,
            PaymentTerms: purchaseData.PaymentTerms,
            ItemName: purchaseData.ItemName,
            Qty: purchaseData.Qty,
            Rate: purchaseData.Rate,
            Remark: purchaseData.Remark
        };

        try {

            const response = await postApi(
                "/AddPurchaseVoucher",
                requestBody,

            );

            if (response.status === 1) {

                Swal.fire("Saved!", response.message, "success");
                setModalIsOpen(false);
                await fetchPurchase();

            } else {
                Swal.fire("Error!", response.message, "error");
            }

        } catch (error) {
            console.log(error);
            Swal.fire("Error", "Failed to save Purchase Voucher", "error");
        }
    };
    const handleUpdate = async (e) => {
        e.preventDefault();

        const errors = [];

        if (!purchaseData.PurchaseDate) errors.push("Purchase Date is required");
        if (!purchaseData.VendorCode) errors.push("Vendor is required");
        if (!purchaseData.ItemName) errors.push("Item Name is required");
        if (!purchaseData.Qty) errors.push("Quantity is required");
        if (!purchaseData.Rate) errors.push("Rate is required");

        if (errors.length > 0) {
            Swal.fire({
                icon: "error",
                title: "Validation Error",
                html: errors.map(err => `<div>${err}</div>`).join("")
            });
            return;
        }

        const requestBody = {
            PurchaseId: purchaseData.PurchaseId,
            PurchaseDate: purchaseData.PurchaseDate?.toISOString().split("T")[0],
            VendorCode: purchaseData.VendorCode,
            LocationCode: purchaseData.LocationCode,
            VendorInvoiceNo: purchaseData.VendorInvoiceNo,
            VendorInvoiceDate: purchaseData.VendorInvoiceDate?.toISOString().split("T")[0],
            GstNo: purchaseData.GstNo,
            StateCode: purchaseData.StateCode,
            PaymentTerms: purchaseData.PaymentTerms,
            ItemName: purchaseData.ItemName,
            Qty: purchaseData.Qty,
            Rate: purchaseData.Rate,
            Remark: purchaseData.Remark
        };

        try {

            const response = await postApi(
                "/UpdatePurchaseVoucher",
                requestBody,

            );

            if (response.status === 1) {

                Swal.fire("Updated!", response.message, "success");
                setModalIsOpen(false);
                await fetchPurchase();

            } else {
                Swal.fire("Error!", response.message, "error");
            }

        } catch (error) {
            console.log(error);
            Swal.fire("Error", "Failed to update Purchase Voucher", "error");
        }
    };

    const handleDelete = async (PurchaseId) => {

        try {

            const confirmation = await Swal.fire({
                title: "Are you sure?",
                text: "This action cannot be undone!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Delete it!",
                cancelButtonText: "Cancel"
            });

            if (!confirmation.isConfirmed) return;

            const response = await postApi(
                `/DeletePurchaseVoucher?PurchaseId=${PurchaseId}`
            );

            if (response.status === 1) {

                Swal.fire(
                    "Deleted!",
                    response.message,
                    "success"
                );

                await fetchPurchase();

            } else {

                Swal.fire(
                    "Error!",
                    response.message,
                    "error"
                );
            }

        } catch (error) {

            console.log(error);

            Swal.fire(
                "Error",
                "Failed to delete Purchase Voucher",
                "error"
            );
        }
    };

    const handleExportPDF = () => {
        const doc = new jsPDF();

        const tableColumn = [
            "Vendor ID",
            "Vendor Code",
            "Vendor Name",
            "Mobile No",
            "Mobile No 2",
            "Email",
            "Fuel Charges",
            "Address",
            "Pin Code",
            "Contact Person",
            "State",
            "City"
        ];

        const tableRows = [];

        currentRows.forEach(vendor => {
            tableRows.push([
                vendor.ID,
                vendor.Vendor_Code,
                vendor.Vendor_Name,
                vendor.Mobile_No,
                vendor.Mobile_No_2,
                vendor.Email,
                vendor.Fuel_Charges,
                vendor.Vendor_Adr,
                vendor.Pin_Code,
                vendor.Contact_Person,
                vendor.State_Name,
                vendor.City_Name,
            ]);
        });

        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 30,
            theme: 'grid',
            styles: { fontSize: 7, whiteSpace: "nowarp" }
        });

        doc.save("Vendor_Data.pdf");
    };
    const handleExportExcel = () => {
        const exportData = currentRows.map((v, index) => ({
            "Vendor ID": v.ID,
            "Vendor Code": v.Vendor_Code,
            "Vendor Name": v.Vendor_Name,
            "Mobile No": v.Mobile_No,
            "Mobile No 2": v.Mobile_No_2,
            "Email": v.Email,
            "Fuel Charges": v.Fuel_Charges,
            "Address": v.Vendor_Adr,
            "Pin Code": v.Pin_Code,
            "Contact Person": v.Contact_Person,
            "State": v.State_Name,
            "City": v.City_Name,
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Vendor Data');

        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
        });

        const file = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        });

        saveAs(file, 'Vendor_Data.xlsx');
    };


    const handlePreviousPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);
    const handleNextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error.message}</div>;



    return (
        <>

            <div className="body">
                <div className="container1">

                    <div className="addNew">
                        <div>
                            <button
                                className="add-btn"
                                onClick={() => {
                                    setModalIsOpen(true);
                                    setIsEditMode(false);

                                    setPurchaseData({
                                        PurchaseId: "",
                                        PurchaseDate: new Date(),
                                        VendorCode: "",
                                        LocationCode: JSON.parse(localStorage.getItem("Login"))?.Branch_Code || "",
                                        VendorInvoiceNo: "",
                                        VendorInvoiceDate: new Date(),
                                        GstNo: "",
                                        StateCode: "",
                                        PaymentTerms: "",
                                        ItemName: "",
                                        Qty: 0,
                                        Rate: 0,
                                        Remark: ""
                                    });
                                }}
                            >
                                <i className="bi bi-plus-lg"></i>
                                <span>ADD NEW</span>
                            </button>

                            <div className="dropdown">
                                <button className="dropbtn">
                                    <i className="bi bi-file-earmark-arrow-down"></i> Export
                                </button>

                                <div className="dropdown-content">
                                    <button onClick={handleExportExcel}>
                                        Export to Excel
                                    </button>

                                    <button onClick={handleExportPDF}>
                                        Export to PDF
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="search-input">
                            <input
                                className="add-input"
                                type="text"
                                placeholder="Search Purchase Voucher..."
                                value={searchQuery}
                                onChange={handleSearchChange}
                            />

                            <button type="button" title="Search">
                                <i className="bi bi-search"></i>
                            </button>
                        </div>
                    </div>
                    <div className="table-container">
                        <table className="table table-bordered table-sm" style={{ whiteSpace: "nowrap" }}>
                            <thead className="table-sm">
                                <tr>
                                    <th className="w-60">Actions</th>
                                    <th>Purchase ID</th>
                                    <th>Purchase Date</th>
                                    <th>Vendor</th>
                                    <th>Vendor Invoice No</th>
                                    <th>Vendor Invoice Date</th>
                                    <th>GST No</th>
                                    <th>State</th>
                                    <th>Payment Terms</th>
                                    <th>Item Name</th>
                                    <th>Qty</th>
                                    <th>Rate</th>
                                    <th>Amount</th>
                                    <th>Remark</th>
                                </tr>
                            </thead>

                            <tbody className="table-body">
                                {currentRows.map((purchase, index) => (
                                    <tr
                                        key={purchase.PurchaseId}
                                        style={{ fontSize: "12px", position: "relative" }}
                                    >
                                        <td>
                                            <PiDotsThreeOutlineVerticalFill
                                                style={{ fontSize: "20px", cursor: "pointer" }}
                                                onClick={() =>
                                                    setOpenRow(openRow === index ? null : index)
                                                }
                                            />

                                            {openRow === index && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        flexDirection: "row",
                                                        position: "absolute",
                                                        alignItems: "center",
                                                        left: "63px",
                                                        top: "1px",
                                                        borderRadius: "10px",
                                                        backgroundColor: "white",
                                                        zIndex: "999999",
                                                        height: "24px",
                                                        width: "70px",
                                                        padding: "10px",
                                                    }}
                                                >
                                                    <button
                                                        className="edit-btn"
                                                        onClick={() => {
                                                            setIsEditMode(true);
                                                            setOpenRow(null);


                                                            setPurchaseData({
                                                                PurchaseId: purchase.PurchaseId,
                                                                PurchaseDate: convertDate(purchase.PurchaseDate),
                                                                LocationCode:purchase.LocationCode,
                                                                VendorCode: purchase.VendorCode,
                                                                VendorInvoiceNo: purchase.VendorInvoiceNo,
                                                                VendorInvoiceDate: convertDate(purchase.VendorInvoiceDate),
                                                                GstNo: purchase.GstNo,
                                                                StateCode: purchase.StateCode,
                                                                PaymentTerms: purchase.PaymentTerms,
                                                                ItemName: purchase.ItemName,
                                                                Qty: purchase.Qty,
                                                                Rate: purchase.Rate,
                                                                Remark: purchase.Remark,
                                                            });

                                                            setModalIsOpen(true);
                                                        }}
                                                    >
                                                        <i className="bi bi-pen"></i>
                                                    </button>

                                                    <button
                                                        className="edit-btn"
                                                        onClick={() => {
                                                            setOpenRow(null);
                                                            handleDelete(
                                                                purchase.PurchaseId
                                                            );
                                                        }}
                                                    >
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                </div>
                                            )}
                                        </td>

                                        <td>{purchase.PurchaseId}</td>
                                        <td>{purchase.PurchaseDate}</td>
                                        <td>{purchase.Vendor_Name}</td>
                                        <td>{purchase.VendorInvoiceNo}</td>
                                        <td>{purchase.VendorInvoiceDate}</td>
                                        <td>{purchase.GstNo}</td>
                                        <td>{purchase.StateCode}</td>
                                        <td>{purchase.PaymentTerms}</td>
                                        <td>{purchase.ItemName}</td>
                                        <td>{purchase.Qty}</td>
                                        <td>{purchase.Rate}</td>
                                        <td>{Number(purchase.Qty) * Number(purchase.Rate)}</td>
                                        <td>{purchase.Remark}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="row" style={{ whiteSpace: "nowrap" }}>
                        <div className="pagination col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0">
                            <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                                {'<'}
                            </button>
                            <span style={{ color: "#333", padding: "5px" }}>
                                Page {currentPage} of {totalPages}
                            </span>
                            <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                                {'>'}
                            </button>
                        </div>

                        <div className="rows-per-page col-12 col-md-6 d-flex justify-content-center justify-content-md-end align-items-center">
                            <span htmlFor="rowsPerPage" className="me-2">Rows per page: </span>
                            <select
                                id="rowsPerPage"
                                value={rowsPerPage}
                                onChange={(e) => {
                                    setRowsPerPage(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                                style={{ height: "40px", width: "50px" }}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                            </select>
                        </div>
                    </div>


                    <Modal overlayClassName="custom-overlay" isOpen={modalIsOpen}
                        className="custom-modal-vendor" contentLabel="Modal"
                        style={{
                            content: {
                                width: '90%',
                                top: '50%',             // Center vertically
                                left: '50%',
                                whiteSpace: "nowrap"
                            },
                        }}>
                        <div className="custom-modal-content">
                            <div className="header-tittle">
                                <header>
                                    Purchase Voucher Master
                                </header>
                            </div>

                            <div className="container2">
                                <form onSubmit={handleSave}>

                                    <div className="fields2">

                                        {/* Purchase Date */}

                                        <div className="input-field3">
                                            <label>Purchase Date</label>

                                            <DatePicker
                                                required
                                                portalId="root-portal"
                                                selected={
                                                    purchaseData.PurchaseDate

                                                }
                                                onChange={(date) =>
                                                    setPurchaseData({
                                                        ...purchaseData,
                                                        PurchaseDate: date,
                                                    })
                                                }
                                                dateFormat="dd/MM/yyyy"


                                            />
                                        </div>


                                        {/* Vendor */}
                                        <div className="input-field3">
                                            <label>Vendor Name</label>
                                            <Select
                                                className="blue-selectbooking"
                                                classNamePrefix="blue-selectbooking"
                                                options={getVendor.map(ven => ({
                                                    value: ven.Vendor_Code,   // adjust keys from your API
                                                    label: ven.Vendor_Name
                                                }))}
                                                value={
                                                    purchaseData.VendorCode
                                                        ? { value: purchaseData.VendorCode, label: getVendor.find(ven => ven.Vendor_Code === purchaseData.VendorCode)?.Vendor_Name || "" }
                                                        : null
                                                }
                                                onChange={(selectedOption) => {
                                                    setPurchaseData({
                                                        ...purchaseData,
                                                        VendorCode: selectedOption ? selectedOption.value : ""
                                                    })
                                                }}
                                                placeholder="Select Vendor"
                                                isSearchable
                                                menuPortalTarget={document.body} // ✅ Moves dropdown out of scroll area
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }) // ✅ Keeps it above other UI
                                                }}
                                            />

                                        </div>


                                        {/* Vendor Invoice No */}
                                        <div className="input-field3">
                                            <label>Vendor Invoice No</label>
                                            <input
                                                type="text"
                                                className="input"
                                                placeholder="Enter Vendor Invoice No"
                                                value={purchaseData.VendorInvoiceNo}
                                                onChange={(e) =>
                                                    setPurchaseData({
                                                        ...purchaseData,
                                                        VendorInvoiceNo: e.target.value,
                                                    })
                                                }
                                            />
                                        </div>

                                        {/* Vendor Invoice Date */}

                                        <div className="input-field3">
                                            <label>Vendor Invoice Date</label>

                                            <DatePicker
                                                required
                                                portalId="root-portal"
                                                selected={
                                                    purchaseData.VendorInvoiceDate

                                                }
                                                onChange={(date) =>
                                                    setPurchaseData({
                                                        ...purchaseData,
                                                        VendorInvoiceDate: date,
                                                    })
                                                }
                                                dateFormat="dd/MM/yyyy"

                                            />
                                        </div>


                                        {/* GST */}
                                        <div className="input-field3">
                                            <label>GST No</label>
                                            <input
                                                type="text"
                                                className="input"
                                                placeholder="Enter GST No"
                                                value={purchaseData.GstNo}
                                                onChange={(e) =>
                                                    setPurchaseData({
                                                        ...purchaseData,
                                                        GstNo: e.target.value,
                                                    })
                                                }
                                            />
                                        </div>

                                        {/* State */}
                                        <div className="input-field3">
                                            <label>State</label>
                                            <Select
                                                className="blue-selectbooking"
                                                classNamePrefix="blue-selectbooking"
                                                options={state.map((st) => ({
                                                    value: st.State_Code,
                                                    label: st.State_Name,
                                                }))}
                                                value={
                                                    purchaseData.StateCode
                                                        ? {
                                                            value: purchaseData.StateCode,
                                                            label:
                                                                state.find(
                                                                    (st) => st.State_Code === purchaseData.StateCode
                                                                )?.State_Name || "",
                                                        }
                                                        : null
                                                }
                                                onChange={(selected) =>
                                                    setPurchaseData({
                                                        ...purchaseData,
                                                        StateCode: selected?.value || "",
                                                    })
                                                }
                                                placeholder="Select State"
                                                isSearchable
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),
                                                }}
                                            />
                                        </div>

                                        {/* Payment Terms */}
                                        <div className="input-field3">
                                            <label>Payment Terms</label>
                                            <input
                                                type="text"
                                                className="input"
                                                placeholder="Enter Payment Terms"
                                                value={purchaseData.PaymentTerms}
                                                onChange={(e) =>
                                                    setPurchaseData({
                                                        ...purchaseData,
                                                        PaymentTerms: e.target.value,
                                                    })
                                                }
                                            />
                                        </div>

                                        {/* Item Name */}
                                        <div className="input-field3">
                                            <label>Item Name</label>
                                            <input
                                                type="text"
                                                className="input"
                                                placeholder="Enter Item Name"
                                                value={purchaseData.ItemName}
                                                onChange={(e) =>
                                                    setPurchaseData({
                                                        ...purchaseData,
                                                        ItemName: e.target.value,
                                                    })
                                                }
                                            />
                                        </div>

                                        {/* Qty */}
                                        <div className="input-field3">
                                            <label>Qty</label>
                                            <input
                                                type="number"
                                                className="input"
                                                placeholder="Enter Qty"
                                                value={purchaseData.Qty}
                                                onChange={(e) =>
                                                    setPurchaseData({
                                                        ...purchaseData,
                                                        Qty: e.target.value,
                                                    })
                                                }
                                            />
                                        </div>

                                        {/* Rate */}
                                        <div className="input-field3">
                                            <label>Rate</label>
                                            <input
                                                type="number"
                                                className="input"
                                                placeholder="Enter Rate"
                                                value={purchaseData.Rate}
                                                onChange={(e) =>
                                                    setPurchaseData({
                                                        ...purchaseData,
                                                        Rate: e.target.value,
                                                    })
                                                }
                                            />
                                        </div>

                                        {/* Amount */}
                                        <div className="input-field3">
                                            <label>Amount</label>
                                            <input
                                                type="text"
                                                className="input"
                                                placeholder="Enter Amount"
                                                readOnly
                                                value={
                                                    (Number(purchaseData.Qty) || 0) *
                                                    (Number(purchaseData.Rate) || 0)
                                                }
                                            />
                                        </div>

                                        {/* Remark */}
                                        <div className="input-field3">
                                            <label>Remark</label>
                                            <input
                                                type="text"
                                                className="input"
                                                placeholder="Enter Remark"
                                                value={purchaseData.Remark}
                                                onChange={(e) =>
                                                    setPurchaseData({
                                                        ...purchaseData,
                                                        Remark: e.target.value,
                                                    })
                                                }
                                            />
                                        </div>

                                    </div>

                                    <div className="bottom-buttons">
                                        {!isEditMode && (
                                            <button
                                                type="submit"
                                                className="ok-btn"
                                                onClick={handleSave}
                                            >
                                                Submit
                                            </button>
                                        )}

                                        {isEditMode && (
                                            <button
                                                type="button"
                                                className="ok-btn"
                                                onClick={handleUpdate}
                                            >
                                                Update
                                            </button>
                                        )}

                                        <button
                                            type="button"
                                            className="ok-btn"
                                            onClick={() => {
                                                setModalIsOpen(false);
                                            }}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Modal >
                </div>
            </div>
        </>
    );
};

export default Purchase;